export enum SpreadSheetStatusDto {
  pendente = 'pendente',
  aceita = 'aceita',
  recusada = 'recusada',
  cancelada = 'cancelada',
  processada = 'processada'
}
